export const actions = {
    START_CREATE_IDENTITYROLE: "START_CREATE_IDENTITYROLE",
    CREATE_IDENTITYROLE_SUCCESSFUL: "CREATE_IDENTITYROLE_SUCCESSFUL",
    CREATE_IDENTITYROLE_FAILED: "CREATE_IDENTITYROLE_FAILED",

    START_DELETE_IDENTITYROLE: "START_DELETE_IDENTITYROLE",
    DELETE_IDENTITYROLE_SUCCESSFUL: "DELETE_IDENTITYROLE_SUCCESSFUL",
    DELETE_IDENTITYROLE_FAILED: "DELETE_IDENTITYROLE_FAILED",

    START_UPDATE_IDENTITYROLE: "START_UPDATE_IDENTITYROLE",
    UPDATE_IDENTITYROLE_SUCCESSFUL: "UPDATE_IDENTITYROLE_SUCCESSFUL",
    UPDATE_IDENTITYROLE_FAILED: "UPDATE_IDENTITYROLE_FAILED",

    START_FETCH_IDENTITYROLE_LIST: "START_FETCH_IDENTITYROLE_LIST",
    FETCH_IDENTITYROLE_LIST_SUCCESSFUL: "FETCH_IDENTITYROLE_LIST_SUCCESSFUL",
    FETCH_IDENTITYROLE_LIST_FAILED: "FETCH_IDENTITYROLE_LIST_FAILED",

    START_FETCH_IDENTITYROLE_LIST_INITIAL_COUNT: "START_FETCH_IDENTITYROLE_LIST_INITIAL_COUNT",
    FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_SUCCESSFUL:
        "FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_SUCCESSFUL",
    FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_FAILED: "FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_FAILED",
};

export const initialState = {};

export default (state = initialState, { type, iri, response }) => {
    switch (type) {
        case actions.FETCH_IDENTITYROLE_LIST_SUCCESSFUL:
            return { ...state, [iri]: response };
        case actions.FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_SUCCESSFUL:
            return { ...state, [iri]: response };
        default:
            return state;
    }
};
